import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import CircularProgress from '@mui/material/CircularProgress'



const InventoryQuantity = ({iid, defaultQuantity, ...rest}) => {
    const app = React.useContext(AppContext)
    const { quantity, refresh } = app.inventories
    const [newQuantity, setNewQuantity] = React.useState(defaultQuantity)
    const [loading, setLoading] = React.useState(false)
    const [disabled, setDisabled] = React.useState(true)
    
    React.useEffect(() => {
        setDisabled(defaultQuantity == newQuantity)
    }, [newQuantity])

    const onChange = (e) => {
        const value = (e.target || e.currentTarget).value
        setNewQuantity(isNaN(value)? defaultQuantity : value)
    }

    const onClick = () => {
        setLoading(true)
        setDisabled(true)
        quantity(iid, newQuantity, () => {
            setLoading(false)
            refresh()
        }, () => {
            setNewQuantity(defaultQuantity)
        })
    }
    
    return (
        <FormControl sx={{ m: 1, width: '25ch' }}>
            <TextField 
                type="number"
                name='quanitty'
                defaultValue={defaultQuantity}
                onChange={onChange}
            />
            <Button onClick={onClick} disabled={disabled || loading}>Ok</Button>
        </FormControl>
        )
    }
    export default InventoryQuantity